import {
   CommunicationDashboardData,
   DashboardChartCommunicationPayload,
   DashboardChartLeadSourceBreakdownParams,
   DashboardChartLeadSourceBreakdownResponse,
   DashboardChartLeadSourceResponse,
   DashboardChartOverviewResponse,
   DashboardChartTeamPerformancePayload,
   ResponseSuccess,
   TeamPerformanceData,
   TimePeriod,
} from '@forwardflow/types'
import { apiGet } from '../Axios/configs'

export default class DashboardService {
   // Get dashboard data
   static async getDashboardData() {
      const data = await apiGet<ResponseSuccess<any>>({
         apiPath: `/dashboard`,
      })
      return data.data
   }

   // dashboard-charts/overview
   static async getDashboardChartsOverview(timePeriod: TimePeriod) {
      const data = await apiGet<
         ResponseSuccess<DashboardChartOverviewResponse>
      >({
         apiPath: `/dashboard-charts/overview?timeFrame=${timePeriod}`,
      })
      return data.data
   }

   // dashboard-charts/lead-source
   static async getDashboardChartsLeadSource(timePeriod: TimePeriod) {
      const data = await apiGet<
         ResponseSuccess<DashboardChartLeadSourceResponse>
      >({
         apiPath: `/dashboard-charts/lead-source?timeFrame=${timePeriod}`,
      })
      return data.data
   }

   // dashboard-charts/lead-source/breakdown
   static async getDashboardChartsLeadSourceBreakdown(
      payload: DashboardChartLeadSourceBreakdownParams
   ) {
      const data = await apiGet<
         ResponseSuccess<DashboardChartLeadSourceBreakdownResponse>
      >({
         apiPath: `/dashboard-charts/leadsource-breakdown?timeFrame=${payload.timePeriod}&page=${payload.page}&perPage=${payload.perPage}&sortBy=${payload.sortBy}&sortOrder=${payload.sortOrder}`,
      })
      return data.data
   }

   // dashboard-charts/communication
   static async getDashboardChartsCommunication(
      payload: DashboardChartCommunicationPayload
   ) {
      const { timePeriod, agentType = 'all' } = payload
      const data = await apiGet<ResponseSuccess<CommunicationDashboardData>>({
         apiPath: `/dashboard-charts/communication?timeFrame=${timePeriod}&agentType=${agentType}`,
      })
      return data.data
   }

   // dashboard-charts/team-performance
   static async getDashboardChartsTeamPerformance(
      payload: DashboardChartTeamPerformancePayload
   ) {
      const data = await apiGet<ResponseSuccess<TeamPerformanceData>>({
         apiPath: `/dashboard-charts/team-performance?timeFrame=${payload.timeFrame}`,
      })
      return data.data
   }
}
